import { Arkiv } from '../../../models/arkiv';
import RequestService from '../requestService';
import { client } from '../../client';
import { Funksjon } from '../../../models';


export default class FunksjonService extends RequestService<Funksjon, 'funksjon'> {
    funksjonerFinnes = async () => client.get<boolean>(`${this.serviceName}/funksjonerFinnes`);
}